import React from 'react';
import { getPaginationDisplay } from './profileUsers';

type Props = {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    itemsPerPage: number;
    onPrevious: () => void;
    onNext: () => void;
};

const ProfilePagination: React.FC<Props> = ({
    currentPage,
    totalPages,
    totalItems,
    itemsPerPage,
    onPrevious,
    onNext,
}) => {
    const { from, to } = getPaginationDisplay(totalItems, currentPage, itemsPerPage);

    return (
        <div className="pagination-fixed-container">
            <div className="users-pagination">
                <button
                    type="button"
                    className="users-pagination-prev"
                    onClick={onPrevious}
                    disabled={currentPage === 1 || totalItems === 0}
                >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: '-5px' }}>
                        <path d="M15.8333 10L4.16668 10M4.16668 10L10 15.8334M4.16668 10L10 4.16669" stroke="#FCFCFD" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    Previous
                </button>
                <span className="users-pagination-info">
                    Showing {from} to {to} of {totalItems} users
                </span>
                <button
                    type="button"
                    className="users-pagination-next"
                    onClick={onNext}
                    disabled={totalItems === 0 || currentPage >= totalPages}
                >
                    Next
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: '-5px' }}>
                        <path d="M4.16675 9.99996H15.8334M15.8334 9.99996L10.0001 4.16663M15.8334 9.99996L10.0001 15.8333" stroke="#FCFCFD" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
            </div>
        </div>
    );
};

export default ProfilePagination;
